import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { workspaceService } from "../../services/api";
export function useWorkspace() {
  return useQuery({
    queryKey: ["workspace"],
    queryFn: workspaceService.overview,
    staleTime: 15000,
    refetchInterval: 30000,
  });
}
export function WorkspaceRefresh() {
  const client = useQueryClient();
  useEffect(() => {
    let timer;
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        client.invalidateQueries({ queryKey: ["workspace"] });
        client.invalidateQueries({ queryKey: ["workspace-search"] });
        client.invalidateQueries({ queryKey: ["workspace-preferences"] });
      }, 250);
    };
    window.addEventListener("timelyzer:records-changed", refresh);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("timelyzer:records-changed", refresh);
    };
  }, [client]);
  return null;
}
export const timeLabel = (value, timezone, options = {}) =>
  value
    ? new Intl.DateTimeFormat(undefined, {
        timeZone: timezone || "UTC",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        ...options,
      }).format(new Date(value))
    : "No time set";
